import { useEffect } from 'react';

import { setExperimentPersonProperties } from '@/lib/analytics';
import { useMyExperimentAssignments } from '@/lib/api/hooks';

/**
 * Resolves the authed patient's experiment assignments and stamps them
 * onto the PostHog person as `$experiment_<key>` properties.
 *
 * AppLayout already does this for `/app/*` routes, but the post-purchase
 * upsell ALSO mounts inside OnboardingShell — and fresh post-purchase
 * patients fire `upsell_viewed` from `/onboarding/welcome`, often without
 * ever visiting `/app` afterwards. Without this mount their person never
 * gets the cohort properties and variant breakdowns on upsell funnels
 * come back "(empty string)" for nearly everyone.
 *
 * Person-property breakdowns are retroactive (PostHog uses the person's
 * latest value), so it doesn't matter that `upsell_viewed` may fire
 * before this query resolves — the $set that follows attributes the
 * earlier events too. Calling `/experiments/me/assignments` here also
 * snapshots the marketing `exp_assignments` cookie earlier (right after
 * checkout, when it's freshest) instead of waiting for the first `/app`
 * load. Shares AppLayout's TanStack query key, so mounting both costs
 * one request.
 */
export function ExperimentCohortSync() {
  const { data } = useMyExperimentAssignments();
  useEffect(() => {
    if (data?.assignments) setExperimentPersonProperties(data.assignments);
  }, [data]);
  return null;
}
